export const leftPanelRoutes = [
  { path: '/shopping-cart/'             , componentPath: 'catalogv2/left-panel/shopping-cart' },
  { path: '/pending-order-panel/'       , componentPath: 'orders/left-panel/pending-order-panel' },
  { path: '/pending-refund-panel/'      , componentPath: 'refunds/left-panel/pending-refund-panel' },
  { path: '/pending-charge-panel/'      , componentPath: 'charges/left-panel/pending-charge-panel' },
  { path: '/checkout-order-panel/'      , componentPath: 'orders/left-panel/checkout-order-panel' },
  { path: '/checkout-charge-panel/'     , componentPath: 'charges/left-panel/checkout-charge-panel' },
  { path: '/client-management-panel/'   , componentPath: 'clients/left-panel/client-management-panel' },
];
